// @flow

import React from 'react';
import { ErrorMessage, ErrorWrapper } from './error.styled';

type Props = {
  className?: string,
  message: ?string,
  general?: boolean,
};

const Error = ({ className, message, general }: Props) => (
  <ErrorWrapper className={className} general={general || false}>
    <ErrorMessage>{message}</ErrorMessage>
  </ErrorWrapper>
);

Error.defaultProps = {
  className: '',
  general: false,
};

export default Error;
